import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const EmojiIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "Emoji",
    children: /*#__PURE__*/_jsx("path", {
      d: "M16 30C8.27 30 2 23.73 2 16S8.27 2 16 2s14 6.27 14 14-6.27 13.99-14 14m0-26C9.37 4 4 9.37 4 16s5.37 12 12 12 12-5.37 12-12c0-6.62-5.37-11.99-12-12m6.48 9.87c0 1.09-.88 1.97-1.97 1.97s-1.97-.88-1.97-1.97.88-1.97 1.97-1.97 1.97.88 1.97 1.97m-10.99-1.99c1.09 0 1.97.88 1.97 1.97s-.88 1.97-1.97 1.97-1.97-.88-1.97-1.97.88-1.97 1.97-1.97m11.63 9.04c-1.94 1.56-4.4 2.53-7.1 2.6H16c-2.71-.08-5.18-1.07-7.12-2.66l.02.02a.98.98 0 0 1-.33-.73c0-.24.09-.46.23-.63.18-.2.44-.33.73-.33.24 0 .46.09.63.24a9.94 9.94 0 0 0 5.82 2.21H16c2.23-.09 4.26-.89 5.88-2.18l-.02.02c.17-.14.39-.23.63-.23.29 0 .54.13.72.32.14.17.23.39.23.63 0 .29-.13.55-.32.73Z"
    })
  }));
};